import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import {
  DigestSubscription,
  DigestHistory,
  DigestComponentOption,
  DigestSubscriptionRequest,
  Page,
  DigestFrequency,
} from "./dtos";

const DIGEST_SUBSCRIPTION_SERVICE = `${Constants.API_URL}/bedrock/digest_subscriptions`;

export interface DigestSubscriptionFilterParams {
  search?: string;
  frequency?: DigestFrequency;
  active?: boolean;
  page?: number;
  perPage?: number;
}

export interface DigestOptionsParams {
  email: string;
  frequency: DigestFrequency;
}

export class DigestSubscriptionServices {
  @scCatchServiceException()
  static async getSubscriptions(params?: DigestSubscriptionFilterParams): Promise<Page<DigestSubscription>> {
    const { data } = await axios.get<Page<DigestSubscription>>(DIGEST_SUBSCRIPTION_SERVICE, { params });
    return data;
  }

  @scCatchServiceException()
  static async getSubscription(id: string | number): Promise<DigestSubscription> {
    const { data } = await axios.get<DigestSubscription>(`${DIGEST_SUBSCRIPTION_SERVICE}/${id}`);
    return data;
  }

  @scCatchServiceException()
  static async getOptions(params: DigestOptionsParams): Promise<DigestComponentOption[]> {
    const { data } = await axios.get<DigestComponentOption[]>(`${DIGEST_SUBSCRIPTION_SERVICE}/options`, { params });
    return data;
  }

  @scCatchServiceException()
  static async createSubscription(request: DigestSubscriptionRequest): Promise<DigestSubscription> {
    const { data } = await axios.post<DigestSubscription>(DIGEST_SUBSCRIPTION_SERVICE, {
      digest_subscription: request,
    });
    return data;
  }

  @scCatchServiceException()
  static async updateSubscription(
    id: string | number,
    request: DigestSubscriptionRequest
  ): Promise<DigestSubscription> {
    const { data } = await axios.patch<DigestSubscription>(`${DIGEST_SUBSCRIPTION_SERVICE}/${id}`, {
      digest_subscription: request,
    });
    return data;
  }

  @scCatchServiceException()
  static async deleteSubscription(id: string | number): Promise<void> {
    await axios.delete(`${DIGEST_SUBSCRIPTION_SERVICE}/${id}`);
  }

  @scCatchServiceException()
  static async getHistory(
    id: string | number,
    params?: { page?: number; perPage?: number }
  ): Promise<Page<DigestHistory>> {
    const { data } = await axios.get<Page<DigestHistory>>(`${DIGEST_SUBSCRIPTION_SERVICE}/${id}/history`, { params });
    return data;
  }

  @scCatchServiceException()
  static async sendTest(id: string | number, email?: string): Promise<{ message: string }> {
    const { data } = await axios.post(`${DIGEST_SUBSCRIPTION_SERVICE}/${id}/send_test`, { email });
    return data;
  }
}
